import React from "react"

type SimulationConnectionIssueModalProps = {
  isOpen: boolean
  retryStatus: string
  onReconnect: () => void
}

const SimulationConnectionIssueModal: React.FC<
  SimulationConnectionIssueModalProps
> = ({ isOpen, retryStatus, onReconnect }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <h2 className="text-xl font-bold mb-4 text-red-600">
          Simulation Connection Issue
        </h2>
        <p className="mb-4 text-gray-700">
          There was a problem saving your progress. Please check your
          connection.
        </p>
        <div className="mb-4 text-gray-500">{retryStatus}</div>
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
          onClick={onReconnect}>
          Reconnect
        </button>
      </div>
    </div>
  )
}

export default SimulationConnectionIssueModal
